export const environment = {
  production: true,
  defaultLanguage: 'en',
  supportedLanguages: ['da', 'en', 'fi', 'nb', 'nl', 'no', 'sv'],
  excludedUrlsFromRetryStrategy: ['/assets/i18n/'],
  api: {
    int: 'https://api.adm2.aws.int.test.visma.net',
    sit: 'https://api.adm2.sit.test.visma.net',
    stag: 'https://api.adm2.stag.visma.net',
    prod: 'https://api.adm2.visma.net'
  },
  vismaHomeUri: {
    localhost: 'https://home.stag.visma.com/',
    int: 'https://home.aws.int.test.visma.net/',
    stag: 'https://home.stag.visma.com/',
    prod: 'https://home.visma.com/'
  },
  mock: {
    enabled: true,
    requests: [],
    pathParamsShouldNotBeSentFor: ['userByEmail'],
    api: {
      int: 'https://api-mock.adm2.aws.int.test.visma.net',
      sit: 'https://api-mock.adm2.sit.test.visma.net',
      stag: 'https://api-mock.adm2.stag.visma.net',
      prod: 'https://api-mock.adm2.visma.net'
    }
  },
  skipLoadingInterceptor: ['/webapi/rest/user/queuedOperation', '/webapi/rest/notifications']
};
